import { Dispatch, SetStateAction } from 'react'
import { useOutletContext } from 'react-router-dom'

export interface ContextProps {
  step: 1 | 2 | 3 | 4 | 5
}

export interface Context {
  step: ContextProps['step']
  setStep: Dispatch<SetStateAction<ContextProps['step']>>
}

export function useContextStep() {
  const { step, setStep } = useOutletContext<Context>()
  return [step, setStep] as const
}
